import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
  button: {
    minWidth: '140px',
    marginTop: theme.spacing(2),
    padding: theme.spacing(1),
  },
}));

export default function AutoCreateSuccess({ handleClose }) {
  const classes = useStyles();

  return (
    <>
      <Typography paragraph>
        If everything’s in order, submit your Lines <br />
        to receive a custom Growth Plan.
      </Typography>
      <Button
        color="primary"
        variant="contained"
        className={classes.button}
        onClick={() => {
          handleClose({ successClose: true });
        }}
      >
        Review Lines
      </Button>
    </>
  );
}
